import { AuthProvider } from 'context/AuthContext';
import { BrowserRouter as Router } from 'react-router-dom';
import { useClearAllSessionStorage } from 'hooks/useClearAllSessionStorage';

import routes, { renderRoutes } from 'routers/routes';

function App() {
  return (
    <>
      <Router>
        <AppContent />
      </Router>
    </>
  );
}

function AppContent() {
  useClearAllSessionStorage();
  
  return (
      <AuthProvider>
        {renderRoutes(routes)}
      </AuthProvider>
  );
}

export default App;
